import * as Sentry from '@sentry/react';
import { apiRoutes } from '@/@auth/authApi';

console.log('Sentry initialized with mode:', import.meta.env.MODE);

// Build regexes from auth API routes so we block network detail logging
// for these endpoints regardless of domain.
const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
const authDenyRegex: RegExp[] = Object.values(apiRoutes).map((p) => new RegExp(escapeRegExp(p)));

Sentry.init({
    dsn: 'https://0022dbe28f83791bf822f0b2fec24ae8@o4507612292972544.ingest.de.sentry.io/4507612294873168',
    sendDefaultPii: true,
    enabled: !import.meta.env.DEV,
    environment: import.meta.env.MODE,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            // Do not capture request/response bodies for auth-related endpoints
            // (matches paths from `apiRoutes`, will work for any domain)
            networkDetailDenyUrls: authDenyRegex,
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1, // Capture 100% of transactions for performance monitoring
    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1, // 100% of sessions with errors  
});